// extracted by mini-css-extract-plugin
export default {"bodyContainer":"kycReminderModal_bodyContainer__AU+1W"};